export enum AccountType {
	Flinker = 'Flinker',
	FlinkCompanyMaster = 'FlinkCompanyMaster',
	FlinkCompanyLimited = 'FlinkCompanyLimited',
	FlinkCompanyContributor = 'FlinkCompanyContributor',
	FlinkAdmin = 'FlinkAdmin',
}
